import map from "ramda/es/map";
/**
 * Resolve all blobs from given files. Returns Promise.all
 *
 * @documented
 * @category Util
 * @example
 *
 * 	getFilesFromBlobUrls([{fieldId: 'file1', name: 'aa.txt', blob: 'http://localhostblob' }])
 *
 */ const getFilesFromBlobUrls = (files)=>Promise.all(map((file)=>fetch(file.blob).then((r)=>r.blob()).then((blob)=>({
                fieldId: file.fieldId,
                fileName: file.name,
                file: blob
            })), files));
export default getFilesFromBlobUrls;
